<template>
  <div>
    <v-row v-if="validations.length">
      <v-col
        v-for="(validation, index) in getValidations"
        :key="index"
        cols="12"
      >
        <template
          v-if="
            validation.FromCustomerType && validation.ToCustomerType != null
          "
        >
          <clientTypeChangeCard
            @deleteOutArray="deleteOutArray($event)"
            :validation="validation"
          />
        </template>
        <template
          v-else-if="validation.FromAddress && validation.ToAddress != null"
        >
          <clientAddressChangeCard
            @deleteOutArray="deleteOutArray($event)"
            :validation="validation"
          />
        </template>
        <template
          v-else-if="
            validation.FromAddress == null && validation.ToAddress != null
          "
        >
          <template v-if="getUpdateAddressCheck(validation)">
            <clientAddNewAddress
              @deleteOutArray="deleteOutArray($event)"
              :validation="validation"
            />
          </template>
          <template v-else>
            <clientAddressUpdate
              @deleteOutArray="deleteOutArray($event)"
              :validation="validation"
            />
          </template>
        </template>
      </v-col>
    </v-row>
    <v-row v-else-if="!loadingValidations">
      <p class="text-h4">
        {{ $t("There are currently no more validation conflicts.") }}
      </p>
    </v-row>
  </div>
</template>
  
  <script>
import clientAddressUpdate from "../shared/emailMarketing/ClientAddressUpdate.vue";
import clientTypeChangeCard from "../shared/emailMarketing/ClientTypeChangeCard.vue";
export default {
  data() {
    return {
      validations: [
        {
          Id: "1",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "1",
            FirstName: "Pol",
            LastName: "Debakker",
            BirthDate: "1980-10-10T01:00:00+01:00",
            Email: "pol.debakker@gmail.com",
            Type: null,
            Address: null,
          },
          CustomersOnFromAddress: null,
          CustomersOnToAddress: [],
          FromCustomerType: null,
          ToCustomerType: null,
          FromAddress: null,
          ToAddress: {
            Id: null,
            Street: "Spanjestraat 141",
            City: "Roeselare",
            Zip: "",
            Country: "B",
          },
        },
        {
          Id: "2",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "2",
            FirstName: "Wim",
            LastName: "Watergroeve",
            BirthDate: "1992-07-29T01:00:00+01:00",
            Email: "wimwatergroeve@hotmail.com",
            Type: {
              Id: "1",
              Name: "Kind",
            },
            Address: {
              Id: "1",
              Street: "Korte meersstraat 112",
              City: "Ieper",
              Zip: "8900",
              Country: "B",
            },
          },
          CustomersOnFromAddress: [],
          CustomersOnToAddress: null,
          FromCustomerType: {
            Id: "1",
            Name: "Kind",
          },
          ToCustomerType: {
            Id: "1",
            Name: "Gezinshoofd",
          },
          FromAddress: null,
          ToAddress: null,
        },
        {
          Id: "3",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "2",
            FirstName: "Marie",
            LastName: "Vandepitte",
            BirthDate: "1996-08-29T01:00:00+01:00",
            Email: "marievandepitte@hotmail.com",
            Type: {
              Id: "1",
              Name: "Kind",
            },
            Address: {
              Id: "1",
              Street: "Korte meersstraat 112",
              City: "Ieper",
              Zip: "8900",
              Country: "B",
            },
          },
          CustomersOnFromAddress: [],
          CustomersOnToAddress: null,
          FromCustomerType: {
            Id: "1",
            Name: "Kind",
          },
          ToCustomerType: {
            Id: "1",
            Name: "Gezinshoofd",
          },
          FromAddress: null,
          ToAddress: null,
        },
        {
          Id: "4",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "1",
            FirstName: "Viktor",
            LastName: "Debakker",
            BirthDate: "1978-11-10T01:00:00+01:00",
            Email: "viktor.debakker@gmail.com",
            Type: null,
            Address: null,
          },
          CustomersOnFromAddress: null,
          CustomersOnToAddress: [],
          FromCustomerType: null,
          ToCustomerType: null,
          FromAddress: null,
          ToAddress: {
            Id: null,
            Street: "Spanjestraat 141",
            City: "",
            Zip: "",
            Country: "B",
          },
        },
        {
          Id: "5",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "2",
            FirstName: "Bert",
            LastName: "Debakker",
            BirthDate: "1973-07-29T01:00:00+01:00",
            Email: "bertdebakker@hotmail.com",
            Type: {
              Id: "1",
              Name: "Kind",
            },
            Address: {
              Id: "1",
              Street: "Korte meersstraat 112",
              City: "Ieper",
              Zip: "8900",
              Country: "B",
            },
          },
          CustomersOnFromAddress: [],
          CustomersOnToAddress: null,
          FromCustomerType: {
            Id: "1",
            Name: "Kind",
          },
          ToCustomerType: {
            Id: "1",
            Name: "Gezinshoofd",
          },
          FromAddress: null,
          ToAddress: null,
        },
        {
          Id: "6",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "2",
            FirstName: "Bart",
            LastName: "Vandebrugge",
            BirthDate: "1973-07-29T01:00:00+01:00",
            Email: "bartvandebrugge@hotmail.com",
            Type: {
              Id: "1",
              Name: "Kind",
            },
            Address: {
              Id: "1",
              Street: "Korte meersstraat 112",
              City: "Ieper",
              Zip: "8900",
              Country: "B",
            },
          },
          CustomersOnFromAddress: [],
          CustomersOnToAddress: null,
          FromCustomerType: {
            Id: "1",
            Name: "Kind",
          },
          ToCustomerType: {
            Id: "1",
            Name: "Gezinshoofd",
          },
          FromAddress: null,
          ToAddress: null,
        },
        {
          Id: "7",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "1",
            FirstName: "Pol",
            LastName: "Debakker",
            BirthDate: "1980-10-10T01:00:00+01:00",
            Email: "pol.debakker@gmail.com",
            Type: null,
            Address: null,
          },
          CustomersOnFromAddress: null,
          CustomersOnToAddress: [],
          FromCustomerType: null,
          ToCustomerType: null,
          FromAddress: null,
          ToAddress: {
            Id: null,
            Street: "",
            City: "Roeselare",
            Zip: "8800",
            Country: "B",
          },
        },
        {
          Id: "8",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "2",
            FirstName: "Jan",
            LastName: "Groenens",
            BirthDate: "1988-07-29T01:00:00+01:00",
            Email: "Jangroenens@hotmail.com",
            Type: {
              Id: "1",
              Name: "Kind",
            },
            Address: {
              Id: "1",
              Street: "Korte meersstraat 112",
              City: "Ieper",
              Zip: "8900",
              Country: "B",
            },
          },
          CustomersOnFromAddress: [],
          CustomersOnToAddress: null,
          FromCustomerType: {
            Id: "1",
            Name: "Kind",
          },
          ToCustomerType: {
            Id: "1",
            Name: "Gezinshoofd",
          },
          FromAddress: null,
          ToAddress: null,
        },
        {
          Id: "9",
          Approved: false,
          Ignored: false,
          Customer: {
            Id: "2",
            FirstName: "Bert",
            LastName: "Vandekerke",
            BirthDate: "1973-07-29T01:00:00+01:00",
            Email: "bertvandekerke@hotmail.com",
            Type: {
              Id: "1",
              Name: "Kind",
            },
            Address: {
              Id: "1",
              Street: "Korte meersstraat 112",
              City: "Ieper",
              Zip: "8900",
              Country: "B",
            },
          },
          CustomersOnFromAddress: [],
          CustomersOnToAddress: null,
          FromCustomerType: {
            Id: "1",
            Name: "Kind",
          },
          ToCustomerType: {
            Id: "1",
            Name: "Gezinshoofd",
          },
          FromAddress: null,
          ToAddress: null,
        },
      ],
      loadingValidations: true,
    };
  },
  components: {
    clientAddressUpdate,
    clientTypeChangeCard,
  },
  computed: {
    getValidations: {
      get() {
        return this.validations;
      },
      set(newItem) {
        this.validations = newItem;
      },
    },
  },

  methods: {
    getUpdateAddressCheck(validation) {
      let check = true;
      for (const key in validation.ToAddress) {
        if (Object.hasOwnProperty.call(validation.ToAddress, key)) {
          if (!validation.ToAddress[key] && key != "Id") {
            check = false;
          }
        }
      }
      return check;
    },
    deleteOutArray(id) {
      this.validations.forEach((element, index) => {
        if (element.Id == id) {
          this.$delete(this.validations, index);
        }
      });
      /* if (this.validations.length == 0) {
        this.getValidationErrors();
      } */
    },
  },
};
</script>
  
  <style>
</style>